module.exports = __webpack_public_path__ + "static/media/board-Dennise_Williams.b419a2b4.jpg";